import { Translate } from 'ra-core'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import italianLang from '../i18n/it'

export const i18nProvider = {
  ...polyglotI18nProvider((locale) => {
    if (locale === 'it') {
      return italianLang
    } else {
      return import(`../i18n/${locale}`).then((messages) => messages.default)
    }
  }, 'it'),
}

export const translate: Translate = (...args) => i18nProvider.translate(...args)
